import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import { toast } from 'react-toastify';
import { FiShield, FiLock } from 'react-icons/fi';
import '../../styles/modern-login.css';

export default function SuperAdminLogin() {
  const [form, setForm] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      await api.post('/superadmin/auth/login', form);
      toast.success('Welcome, Super Admin');
      navigate('/superadmin/dashboard');
    } catch (err) {
      setError(err.response?.data?.msg || 'Login failed');
    } finally { setLoading(false); }
  };

  return (
    <div className="modern-login-page superadmin-theme">
      <div className="modern-login-frame">
        <div className="modern-login-card">
          {/* Logo Icon */}
          <div className="modern-login-icon">
            <FiShield />
          </div>

          {/* Title */}
          <h1 className="modern-login-title">Super Admin</h1>

          {/* Error */}
          {error && <div className="modern-login-error">{error}</div>}

          {/* Form */}
          <form onSubmit={handleSubmit} className="modern-login-form">
            <div className="modern-input-group">
              <FiShield className="input-icon" />
              <input
                type="text"
                placeholder="Admin Username"
                value={form.username}
                onChange={e => setForm({ ...form, username: e.target.value })}
                required
                autoFocus
              />
            </div>

            <div className="modern-input-group">
              <FiLock className="input-icon" />
              <input
                type="password"
                placeholder="Password"
                value={form.password}
                onChange={e => setForm({ ...form, password: e.target.value })}
                required
                autoComplete="current-password"
              />
            </div>

            <button type="submit" className="modern-login-btn" disabled={loading}>
              {loading ? 'Authenticating...' : 'ACCESS CONSOLE'}
            </button>
          </form>

          <a href="/login" className="modern-back-link">
            ← Back to Portal Login
          </a>
        </div>
      </div>
    </div>
  );
}
